import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { DarkCard, LightCard } from '../components/Cards';
import { ImageDecorations } from '../components/Decorations';
export function Workshop() {
  const CTA_LINK = 'https://docs.google.com/forms/d/e/1FAIpQLSd1jwlLel_orq9QCQyytJb0Ur2k3xXmPrVXy_qoxQnjjcw9Rg/viewform';
  return <main className="flex-grow bg-rise-white" data-id="element-1209" data-mp="1m2c77v1r95kc">
      {/* SECȚIUNEA 1 — HERO */}
      <section className="py-12 md:py-20 px-6 bg-rise-white overflow-hidden" data-id="element-1210" data-mp="17dy3zj0fff39">
        <div className="max-w-rise-content mx-auto flex justify-center" data-id="element-1211" data-mp="1c692qijfkuu8">
          {/* Text Content */}
          <div className="flex flex-col items-center text-center max-w-3xl" data-id="element-1212" data-mp="yf433gg2c2jw">
            <span className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-black border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-1213" data-mp="13d5v4qvgvc7i">
              WORKSHOP ONLINE GRATUIT
            </span>
            <h1 className="font-playfair text-[36px] md:text-[52px] text-rise-black leading-tight mb-6" data-id="element-1214" data-mp="te6lb4yytaix">
              Descoperă în 90 de minute ce ai în tine ca să nu mai aștepți din
              exterior
            </h1>

            <p className="font-dm-sans text-[19px] text-rise-gray max-w-xl mx-auto leading-relaxed mb-10" data-id="element-1215" data-mp="fkuompw8bv6o">
              Un workshop practic și transformațional, pentru tineri adulți care
              se simt blocați, nesiguri sau copleșiți și vor să descopere
              resursele pe care le au deja în ei: curaj, claritate, echilibru,
              încredere. Nu teorie. Exerciții reale, lucru în grup și un pas
              concret cu care pleci acasă.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-6 sm:gap-8 mb-10 font-dm-sans text-[15px] text-rise-black w-full" data-id="element-1216" data-mp="anbbxuf6jqgu">
              <div className="flex flex-col items-center" data-id="element-1217" data-mp="5tgm098zef9b">
                <span className="text-rise-gold font-semibold uppercase tracking-wider text-[12px] mb-1" data-id="element-1218" data-mp="3eabgp1fmktcb">
                  Data și ora
                </span>
                <span data-id="element-1219" data-mp="1d95856engntg">[De confirmat]</span>
              </div>
              <div className="hidden sm:block w-px h-10 bg-gray-300" data-id="element-1220" data-mp="1d8vd34eqzqgw"></div>
              <div className="flex flex-col items-center" data-id="element-1221" data-mp="1i76p9lsimd2a">
                <span className="text-rise-gold font-semibold uppercase tracking-wider text-[12px] mb-1" data-id="element-1222" data-mp="1myyjc6avr0x6">
                  Platforma
                </span>
                <span data-id="element-1223" data-mp="1rxi628xasgql">Online, Zoom</span>
              </div>
              <div className="hidden sm:block w-px h-10 bg-gray-300" data-id="element-1224" data-mp="uassr2x5ahpf"></div>
              <div className="flex flex-col items-center" data-id="element-1225" data-mp="z9dwhcblvjim">
                <span className="text-rise-gold font-semibold uppercase tracking-wider text-[12px] mb-1" data-id="element-1226" data-mp="z9vzqswoqy01">
                  Durata
                </span>
                <span data-id="element-1227" data-mp="197a2jpporo9v">90 minute</span>
              </div>
              <div className="hidden sm:block w-px h-10 bg-gray-300" data-id="element-1228" data-mp="198v1drj19tdj"></div>
              <div className="flex flex-col items-center" data-id="element-1229" data-mp="2fmu90r217skg">
                <span className="text-rise-gold font-semibold uppercase tracking-wider text-[12px] mb-1" data-id="element-1230" data-mp="2kmgoz898vmwy">
                  Preț
                </span>
                <span className="font-bold" data-id="element-1231" data-mp="8yu03d0hvs6y">GRATUIT</span>
              </div>
            </div>

            <div className="flex flex-col items-center w-full max-w-md mx-auto" data-id="element-1232" data-mp="40sh0s32jsvh">
              <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors flex items-center justify-center w-full mb-3" data-id="element-1233" data-mp="3vdwl3u9o69c5">
                Rezervă-ți Locul Gratuit la Workshop
              </a>
              <p className="font-dm-sans text-[14px] text-rise-gray/70 italic" data-id="element-1234" data-mp="3cfu33zfjhcnu">
                Locuri limitate pentru a păstra calitatea experienței.
                Înscrie-te acum.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 2 — PROBLEMA */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-1235" data-mp="15pvxzaybkl3c">
        <div className="max-w-rise-content mx-auto" data-id="element-1236" data-mp="3c81ziztx5u6">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-center mb-12 max-w-3xl mx-auto" data-id="element-1237" data-mp="3dj3fc5sy1i4">
            Ce se întâmplă când nu știi că resursele sunt deja în tine...
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-1238" data-mp="3pimur3p3zt05">
            <div className="space-y-6 font-dm-sans text-[19px] text-rise-white/80 leading-relaxed" data-id="element-1239" data-mp="3uhpzso539z84">
              <p data-id="element-1240" data-mp="3ftd0bh6sly8v">
                Te trezești dimineața cu același gând: nu știu ce vreau, nu știu
                dacă pot, nu știu de unde să încep.
              </p>
              <p data-id="element-1241" data-mp="36sx0qit67b9a">
                Îți spui că nu ești pregătit, că alții sunt mai buni, că mai
                aștepți puțin.
              </p>
              <p data-id="element-1242" data-mp="3bt2v46qtrbv2">
                Amâni o decizie importantă: un proiect, o colaborare, o
                schimbare, o conversație dificilă.
              </p>
              <p data-id="element-1243" data-mp="31tu33jfis7bc">
                Simți că pierzi ocazii reale nu pentru că nu ești capabil, ci
                pentru că nu ai încredere că ești.
              </p>
              <p data-id="element-1244" data-mp="2i8bue1d0kpal">
                Te uiți la ceilalți și te întrebi de unde au ei curajul,
                claritatea sau forța de care tu crezi că duci lipsă.
              </p>
              <p data-id="element-1245" data-mp="2s711cz3dgpc2">
                Cauți răspunsuri în exterior: în opinii, în validare, în ce zic
                alții că ar trebui să faci.
              </p>
              <p className="text-rise-gold font-medium text-[22px] italic mt-8" data-id="element-1246" data-mp="316o35m00jx5n">
                Și tot nu te miști. Nu pentru că nu poți. Ci pentru că nu știi
                că ceea ce ai nevoie este deja în tine.
              </p>
            </div>

            <div className="bg-rise-black border border-rise-gold/40 rounded-xl p-8 md:p-10" data-id="element-1247" data-mp="3aw7pj1mxq959">
              <p className="font-dm-sans text-[19px] text-rise-white/90 leading-relaxed mb-8" data-id="element-1248" data-mp="35y65oehoq5sq">
                Am văzut asta de zeci de ori în 9 ani de lucru cu tineri. Oameni
                capabili, inteligenți, cu potențial real, blocați de o singură
                lipsă: nu știau ce resurse au în ei și cum să le folosească. De
                aceea am creat acest workshop.
              </p>
              <div className="flex flex-col items-center" data-id="element-1249" data-mp="3rymva0egf5r0">
                <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-6 py-3 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors inline-flex items-center justify-center w-full text-center mb-3" data-id="element-1250" data-mp="rac5fu0gi8g">
                  Rezervă-ți Locul Gratuit la Workshop
                </a>
                <p className="font-dm-sans text-[13px] text-rise-white/50 italic text-center" data-id="element-1251" data-mp="jhs0z9bq2toj">
                  Locuri limitate pentru a păstra calitatea experienței.
                  Înscrie-te acum.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 3 — CE VEI ÎNVĂȚA */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-1252" data-mp="2q8zws1xgtr5n">
        <div className="max-w-rise-content mx-auto" data-id="element-1253" data-mp="2iph04svatzel">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black text-center mb-16" data-id="element-1254" data-mp="2ir1t4e1ytaac">
            Ce descoperi și practici în acest workshop de 90 de minute
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-1255" data-mp="28xb7ri14xfyv">
            <div className="flex items-start gap-4" data-id="element-1256" data-mp="241dop3yhlvie">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1257" data-mp="31o2y3yviraea">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1258" data-mp="2woqdlks4efev">1</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1259" data-mp="2rp3y14otkn2w">
                Vei identifica exact ce resurse interioare ai activat deja în
                viața ta, fără să fi știut că o faci, și de ce funcționează.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1260" data-mp="1bbx06hdzmyrg">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1261" data-mp="1ba3ub4b78iki">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1262" data-mp="25yvurbr2ae7i">2</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1263" data-mp="25wj6yhymh9mj">
                Vei înțelege cum curajul, claritatea, determinarea sau
                echilibrul nu sunt trăsături cu care te naști, ci resurse pe
                care le poți accesa oricând.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1264" data-mp="2op3s1d82yafs">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1265" data-mp="2oovcfdkkor0w">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1266" data-mp="2ezk8e5cjmcjv">3</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1267" data-mp="32p676rp06prc">
                Vei exersa, prin exerciții ghidate, cum să activezi o resursă
                specifică exact când ai nevoie de ea: într-un moment copleșitor,
                înainte de o decizie sau când vocea interioară îți spune că nu
                poți.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1268" data-mp="qzq8j8acfup4">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1269" data-mp="15qyy5he8xg29">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1270" data-mp="10se45zpl7sm9">4</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1271" data-mp="d2a3a03sa6yy">
                Vei lucra în camere de grup pe Zoom și vei auzi experiențele
                altor oameni care trec prin situații similare cu ale tale. Vei
                înțelege că nu ești singurul și că soluția nu e atât de departe.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1272" data-mp="1yel9xcxmnr07">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1273" data-mp="1yhh72z1nibnl">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1274" data-mp="1fgdeejzitzrg">5</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1275" data-mp="1ah0pltp3aim8">
                Vei pleca cu o resursă personală clară identificată și cu un
                exercițiu simplu pe care îl poți folosi singur de a doua zi.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-1276" data-mp="10p4sakutuwj2">
              <div className="w-10 h-10 rounded-full bg-rise-gold/20 flex items-center justify-center text-rise-gold shrink-0 mt-1" data-id="element-1277" data-mp="vsnueyxtt3ss">
                <span className="font-playfair font-bold text-[20px]" data-id="element-1278" data-mp="rsdrjv5byti5">6</span>
              </div>
              <p className="font-dm-sans text-[19px] text-rise-gray leading-relaxed" data-id="element-1279" data-mp="mtaje1u2075y">
                Vei simți ce înseamnă energia unui grup care lucrează împreună
                spre același scop: claritate, curaj și progres fără judecată.
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center" data-id="element-1280" data-mp="2c6xma31a1aod">
            <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-flex items-center justify-center mb-3" data-id="element-1281" data-mp="2jqf4nd2sbujc">
              Rezervă-ți Locul Gratuit la Workshop
            </a>
            <p className="font-dm-sans text-[14px] text-rise-gray/70 italic" data-id="element-1282" data-mp="2yge2tfucb5yt">
              Locuri limitate pentru a păstra calitatea experienței. Înscrie-te
              acum.
            </p>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 4 — CUM SE SCHIMBĂ VIAȚA TA */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite" data-id="element-1283" data-mp="2ar1wqoub7e0q">
        <div className="max-w-rise-content mx-auto" data-id="element-1284" data-mp="2fotn3efb2s2t">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-white text-center mb-16" data-id="element-1285" data-mp="3m448n6lgrfek">
            Ce se schimbă după acest workshop
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-1286" data-mp="3r1dygncrlt2x">
            <DarkCard title="Nu mai cauți în exterior ce ai în tine" data-id="element-1287" data-mp="1r0fyvids5wk2">
              <p data-id="element-1288" data-mp="1m1v1dqpwxqzb">
                Știi exact cum să accesezi curajul, claritatea sau echilibrul de
                care ai nevoie, fără să aștepți validare, condiții perfecte sau
                momentul potrivit.
              </p>
            </DarkCard>
            <DarkCard title="Iei decizii fără să te blochezi" data-id="element-1289" data-mp="1w1di7yaj0wn5">
              <p data-id="element-1290" data-mp="189ybzufmpv6m">
                Nu mai pierzi oportunități din lipsă de încredere. Înveți să
                acționezi cu resursele pe care le ai deja, nu cu cele pe care
                crezi că îți lipsesc.
              </p>
            </DarkCard>
            <DarkCard title="Știi că nu ești singur în proces" data-id="element-1291" data-mp="1h42xdybzueer">
              <p data-id="element-1292" data-mp="1cbtev3d7kgmi">
                Energia și poveștile grupului îți arată că blocajele tale nu
                sunt unice. Și că alți oameni ca tine au trecut prin ele, cu
                exact aceleași resurse pe care tu le ai deja.
              </p>
            </DarkCard>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 5 — CINE SUNT EU */}
      <section className="py-12 md:py-20 px-6 bg-rise-white overflow-hidden" data-id="element-1293" data-mp="af45nez7qnac">
        <div className="max-w-rise-content mx-auto" data-id="element-1294" data-mp="f900w9o3dw1t">
          <div className="max-w-3xl mx-auto" data-id="element-1295" data-mp="jkaiush3smn">
            <h2 className="font-playfair text-[32px] md:text-[38px] text-rise-black mb-8" data-id="element-1296" data-mp="gobf34w2xwm">
              Cine sunt eu și de ce am creat acest workshop pentru tine
            </h2>
            <div className="space-y-6 font-dm-sans text-[19px] text-rise-gray leading-relaxed mb-10" data-id="element-1297" data-mp="t7zn7ao4tyut">
              <p data-id="element-1298" data-mp="y6169vlk5y6a">
                Sunt <strong data-id="element-1299" data-mp="y46v39039kfe">Teodora Trifu</strong>, consilier pentru dezvoltare
                personală cu 9 ani de experiență în lucrul cu tineri. Sunt
                formată ca lucrător prin arte combinate și folosesc metode
                experiențiale și creative care combină autocunoașterea cu
                acțiunea concretă.
              </p>
              <p data-id="element-1300" data-mp="38znfutw4557t">
                De 5 ani construiesc, prin ONG-ul pe care l-am fondat, spații
                sigure în care tinerii din medii defavorizate învață să se
                cunoască și să se susțină pe ei înșiși.
              </p>
              <p data-id="element-1301" data-mp="3kd5wp1ya622n">
                Am văzut același tipar de zeci de ori: oameni capabili care se
                blochează nu pentru că nu au resurse, ci pentru că nu știu că le
                au. O kinetoterapeută care știa că poate vorbi cu pacienții ei,
                dar o voce interioară o oprea mereu. Un freelancer care evita să
                lanseze proiecte proprii de teamă că nu e suficient de bun. Un
                tânăr absolvent blocat la primul pas dintr-un drum necunoscut.
              </p>
              <p className="font-playfair italic text-rise-gold text-[22px]" data-id="element-1302" data-mp="3t7c7o10r7fm6">
                Toți aveau ce le trebuia. Pur și simplu nu știau unde să caute.
              </p>
              <p data-id="element-1303" data-mp="2mp5j463w5df4">
                Am creat acest workshop ca să te ajut să găsești tu însuți ce ai
                în tine, într-un spațiu sigur, alături de un grup care înțelege
                exact prin ce treci.
              </p>
            </div>
            <div className="flex flex-col items-start" data-id="element-1304" data-mp="128fysfbqtsh3">
              <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-flex items-center justify-center mb-3" data-id="element-1305" data-mp="126v1ihy1nvfj">
                Rezervă-ți Locul Gratuit la Workshop
              </a>
              <p className="font-dm-sans text-[14px] text-rise-gray/70 italic" data-id="element-1306" data-mp="1ky4dcxvaewaa">
                Locuri limitate pentru a păstra calitatea experienței.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite" data-id="element-1307" data-mp="3rrgk2sdcjt16">
        <div className="max-w-rise-content mx-auto grid md:grid-cols-2 gap-12 md:gap-20" data-id="element-1308" data-mp="jc4yvve95rt">
          {/* Pentru cine ESTE */}
          <div data-id="element-1309" data-mp="3oplh5gbckhna">
            <h2 className="font-playfair text-[32px] text-rise-white mb-8 border-b border-rise-gold/30 pb-4" data-id="element-1310" data-mp="3op29qtjbpbni">
              Pentru cine este acest workshop
            </h2>
            <div className="space-y-6" data-id="element-1311" data-mp="2hlv09bhohl1">
              <div className="flex items-start gap-4" data-id="element-1312" data-mp="2f95nb3ej4xy">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={24} data-id="element-1313" data-mp="3tndif0xvtg45" />
                <p className="font-dm-sans text-[18px] text-rise-white/80 leading-relaxed" data-id="element-1314" data-mp="bg7dy5kvhymc">
                  Tineri adulți între 20 și 35 de ani care simt că au potențial,
                  dar ceva din interior îi oprește și vor să înțeleagă ce anume.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-1315" data-mp="g9a5k863axzw">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={24} data-id="element-1316" data-mp="v5hsvhcsofje" />
                <p className="font-dm-sans text-[18px] text-rise-white/80 leading-relaxed" data-id="element-1317" data-mp="q8hln347l6qp">
                  Oameni care trec printr-o perioadă aglomerată sau copleșitoare
                  și au nevoie de claritate și de instrumente simple ca să
                  meargă mai departe.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-1318" data-mp="zwmuwscu3lyx">
                <CheckCircle2 className="text-rise-gold shrink-0 mt-1" size={24} data-id="element-1319" data-mp="14skdl5bkl4ev" />
                <p className="font-dm-sans text-[18px] text-rise-white/80 leading-relaxed" data-id="element-1320" data-mp="q2mie5f83eg6">
                  Oricine a pierdut sau evitat o oportunitate importantă din
                  lipsă de încredere în sine și vrea să schimbe asta concret, nu
                  doar teoretic.
                </p>
              </div>
            </div>
          </div>

          {/* Pentru cine NU ESTE */}
          <div data-id="element-1321" data-mp="76my7gshlf75">
            <h2 className="font-playfair text-[32px] text-rise-white mb-8 border-b border-white/10 pb-4" data-id="element-1322" data-mp="787j0ep01jrt">
              Pentru cine nu este acest workshop
            </h2>
            <div className="space-y-6" data-id="element-1323" data-mp="rmfrde9e9kuk">
              <div className="flex items-start gap-4" data-id="element-1324" data-mp="nldz5hdwa923">
                <XCircle className="text-rise-white/40 shrink-0 mt-1" size={24} data-id="element-1325" data-mp="nlvsa559g75s" />
                <p className="font-dm-sans text-[18px] text-rise-white/60 leading-relaxed" data-id="element-1326" data-mp="io40db4m8l1l">
                  Pentru cei care caută motivație temporară sau citate
                  inspiraționale, fără să fie dispuși să lucreze efectiv pe ei
                  în cadrul exercițiilor.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-1327" data-mp="3w0nxqfiksw54">
                <XCircle className="text-rise-white/40 shrink-0 mt-1" size={24} data-id="element-1328" data-mp="3vz33ys435h8b" />
                <p className="font-dm-sans text-[18px] text-rise-white/60 leading-relaxed" data-id="element-1329" data-mp="3m2qanvcgd5e3">
                  Pentru cei care vor o soluție pasivă, să asculte un curs și să
                  nu participe la exerciții sau la lucrul în grup.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-1330" data-mp="372cegvnpmhxi">
                <XCircle className="text-rise-white/40 shrink-0 mt-1" size={24} data-id="element-1331" data-mp="3bxrr5k9ze7sc" />
                <p className="font-dm-sans text-[18px] text-rise-white/60 leading-relaxed" data-id="element-1332" data-mp="3gw2ztrojic8z">
                  Pentru cei care cred că resursele interioare nu există și că
                  totul depinde exclusiv de circumstanțe externe. Acest workshop
                  pornește de la premisa că ai deja ce îți trebuie.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 7 — TESTIMONIALE */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-1333" data-mp="32zg1bkgxve0y">
        <div className="max-w-rise-content mx-auto" data-id="element-1334" data-mp="25j8xosy7p024">
          <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black text-center mb-16" data-id="element-1335" data-mp="25ihbg8qi8eoi">
            Ce spun oamenii care au lucrat cu mine
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-1336" data-mp="6lttphvc0bly">
            <LightCard title="Kinetoterapeut" data-id="element-1337" data-mp="6neon8lk5wkc">
              <p className="italic mb-4" data-id="element-1338" data-mp="bj2frtjlozsh">
                "Știam că pot, dar ceva mă oprea de fiecare dată. După ce am
                lucrat cu Teodora, am înțeles de unde vine acea frică și am
                învățat să o gestionez. Acum vorbesc cu pacienții mei relaxat și
                deschis."
              </p>
            </LightCard>
            <LightCard title="Mela" data-id="element-1339" data-mp="3jxu9x7rgu2ci">
              <p className="italic mb-4" data-id="element-1340" data-mp="3oyiaak1l3vje">
                "M-ai ajutat să descopăr perspective noi și să îmi dezvolt
                abilitățile de a face față provocărilor. Am descoperit lucruri
                noi despre mine și am învățat să îmi gestionez emoțiile în
                momentele în care nu eram în zona mea de confort."
              </p>
            </LightCard>
            <LightCard title="Marina-Georgiana Burz" data-id="element-1341" data-mp="35b10gj4mnqs8">
              <p className="italic mb-4" data-id="element-1342" data-mp="359hkyuqspjri">
                "Apreciez foarte mult aceste workshop-uri pe care le faceți.
                Sunt interactive, motivaționale și educative. Cu siguranță multe
                persoane se simt ascultate acum."
              </p>
            </LightCard>
            <LightCard title="Alina Nicoleta" data-id="element-1343" data-mp="2opiii5key8sf">
              <p className="italic mb-4" data-id="element-1344" data-mp="2jrqsxi78qyre">
                "Vreau să te felicit, Teo. Îmi place că ai o voce caldă și
                liniștită — inspiri siguranță."
              </p>
            </LightCard>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 8 — CTA FINAL */}
      <section className="py-14 md:py-24 bg-rise-black text-center relative overflow-hidden px-6" data-id="element-1345" data-mp="2a047yu53plbg">
        <div className="absolute inset-0 opacity-10 pointer-events-none flex items-center justify-center" data-id="element-1346" data-mp="250hucjld2324">
          <div className="w-[800px] h-[800px] border-[1px] border-rise-gold rounded-full" data-id="element-1347" data-mp="1w267msnm7pey"></div>
          <div className="absolute w-[600px] h-[600px] border-[1px] border-rise-gold rounded-full" data-id="element-1348" data-mp="1w40l5lwk4f90"></div>
          <div className="absolute w-[400px] h-[400px] border-[1px] border-rise-gold rounded-full" data-id="element-1349" data-mp="1hfgzk2fas3wy"></div>
        </div>

        <div className="max-w-rise-content mx-auto relative z-10" data-id="element-1350" data-mp="1mf3csbv4lk5r">
          <h2 className="font-playfair text-[36px] md:text-[48px] text-rise-white mb-10" data-id="element-1351" data-mp="1mc7e2lbgerg9">
            Ești gata să descoperi ce ai deja în tine?
          </h2>
          <div className="flex flex-col items-center" data-id="element-1352" data-mp="1ch5pprp05teq">
            <a href={CTA_LINK} target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-10 py-5 rounded-xl font-dm-sans font-semibold text-[18px] transition-colors inline-flex items-center justify-center mb-4" data-id="element-1353" data-mp="2068f5lpvoqjs">
              Rezervă-ți Locul Gratuit la Workshop
            </a>
            <p className="font-dm-sans text-[16px] text-rise-white/70 italic" data-id="element-1354" data-mp="1vdfasyybnk88">
              Locurile sunt limitate pentru a păstra calitatea lucrului în grup
              și a camerelor de Zoom. Înscrie-te acum și rezervă-ți locul.
            </p>
          </div>
        </div>
      </section>
    </main>;
}